import React, { useEffect, useRef, useState } from "react";
import "./OpportunityFilterContainer.css";
import VerticalDivider from "../../../../HtmlElements/VerticalDivider";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import ChatBox from "../../../genericComponents/chatbotContainer/GenericChatbotContainer";
import OpportunityFilterComponent from "./OpportunityFilterComponent";
import OpportunityFilterComponentSingleton from "./OpportunityFilterComponentSingleton";
import ChatContainerForContact from "../../../genericComponents/chatbotContainer/ChatContainerForContact";
import ChatbotForIds from "../../../genericComponents/chatbotContainer/ChatBotForIds";
import ChatContainerForContactAddSc from "../../../genericComponents/chatbotContainer/ChatContainerForContactAddSc";
import ChatContainerForMeetingPrep from "../../../genericComponents/chatbotContainer/ChatContainerForMeetingPrep";

function OpportunityFilterContainer({
  filterOptions = {},
  mainTitl,
  filterTitl,
  oppBtnTitl,
  filters,
  setFilters,
  filterTxt = "Filters",
  notSingleton = true,
  onApply,
  loading,
  type,
  chatbotBtnTxt = "Add Opportunity",
  disableFilter,
  parentTab,
  disableButton = false,
  container_class = "",
}) {
  const [showAddOppSC, setShowAddOppSC] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  // 🧠 Handle outside click to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <>
      <div className={`opportunity-filter-container ${container_class}`}>
        <span className="opportunity-filter-container-title">{mainTitl}</span>

        <div className="opportunity-filter-container-content">
          {!disableFilter && (
            <>
              <div className="opportunity-filter-section">
                <span className="opportunity-filter-container-or-text">
                  {filterTitl}
                </span>
                <div className="filter-container" ref={dropdownRef}>
                  <div className="filter-dropdown">
                    <button
                      className="custom-dropdown-toggle"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsDropdownOpen((prev) => !prev);
                      }}
                    >
                      {filterTxt}

                      {"  "}
                      {Object.entries(filters).reduce(
                        (sum, [key, value]) => sum + (value?.length || 0),
                        0
                      ) > 0 && (
                        <>
                          (
                          {Object.entries(filters).reduce(
                            (sum, [key, value]) => sum + (value?.length || 0),
                            0
                          )}
                          )
                        </>
                      )}
                      <img src="/img/chevron-down.svg" />
                    </button>

                    {isDropdownOpen && (
                      <div className={`dropdown-content show`}>
                        {notSingleton ? (
                          <OpportunityFilterComponent
                            filterOptions={filterOptions}
                            filters={filters}
                            setFilters={setFilters}
                            loading={loading}
                            setIsDropdownOpen={setIsDropdownOpen}
                          />
                        ) : (
                          <OpportunityFilterComponentSingleton
                            opportunities={filterOptions}
                            selectedIds={selectedIds}
                            setSelectedIds={setSelectedIds}
                            onApply={onApply}
                            loading={loading}
                            setIsDropdownOpen={setIsDropdownOpen}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <VerticalDivider />
            </>
          )}
          {!disableButton && (
            <div className="opportunity-filter-section">
              <span className="opportunity-filter-container-or-text">
                {oppBtnTitl}
              </span>
              <button
                className="add-opportunity-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowAddOppSC(true);
                }}
              >
                {chatbotBtnTxt}
              </button>
            </div>
          )}
        </div>
      </div>

      {parentTab == "tro" && (
        <GenericOverviewSideCard
          showMoreModal={showAddOppSC}
          setShowMoreModal={setShowAddOppSC}
          titleForSideCard={null}
          comp={
            <ChatContainerForContact
              onBack={() => setShowAddOppSC(false)}
              type={"spot"}
            />
          }
          minWidthForDrawer={"30%"}
        />
      )}
      {parentTab == "sc" && (
        <GenericOverviewSideCard
          showMoreModal={showAddOppSC}
          setShowMoreModal={setShowAddOppSC}
          titleForSideCard={null}
          comp={
            <ChatContainerForContactAddSc
              onBack={() => setShowAddOppSC(false)}
              type={"spot"}
            />
          }
          minWidthForDrawer={"30%"}
        />
      )}
      {parentTab == "mp" && (
        <GenericOverviewSideCard
          showMoreModal={showAddOppSC}
          setShowMoreModal={setShowAddOppSC}
          titleForSideCard={null}
          comp={
            <ChatContainerForMeetingPrep
              onBack={() => setShowAddOppSC(false)}
              type={"spot"}
            />
          }
          minWidthForDrawer={"30%"}
        />
      )}

      {parentTab == "ids" && (
        <GenericOverviewSideCard
          showMoreModal={showAddOppSC}
          setShowMoreModal={setShowAddOppSC}
          titleForSideCard={null}
          comp={
            <ChatbotForIds
              onBack={() => setShowAddOppSC(false)}
              type={"spot"}
              onApply={onApply}
            />
          }
          minWidthForDrawer={"30%"}
        />
      )}
    </>
  );
}

export default OpportunityFilterContainer;
